module.exports = __webpack_public_path__ + "static/media/file_error_icon.33ecfc2a.svg";